import Vue from 'vue';

export default new Vue({
    data: function () {
        return {
            force: false,
            previous: '',
            page: 1,
        }
    },
    methods: {
        setForce: function (value) {
           this.force = value
        },
        getForce: function () {
           return this.force
        },
        setPrevious: function (previous) {
            this.previous = previous
        },
        getPrevious: function (previous) {
            return this.previous
        },
        nextPage: function () {
            this.page = this.page + 1
            return this.page
        },
        setPage: function (page) {
            this.page = parseInt(page)
        },
        getPage: function () {
            return this.page
        },
        clearPage: function () {
            this.page = 1
        }
    }
})
